export const ENG_GOOGLE_PLAYSTORE = "https://play.google.com/store/apps/details?id=com.prothomalo.english";
export const ENG_APPLE_PLAYSTORE = "https://apps.apple.com/us/app/english-news-prothom-alo/id1289463331";
export const BN_GOOGLE_PLAYSTORE = "https://play.google.com/store/apps/details?id=com.mcc.prothomalo&hl=en_IN";
export const BN_APPLE_PLAYSTORE = "https://apps.apple.com/us/app/bangla-newspaper-prothom-alo/id548596669";
export const NA_APPLE_PLAYSTORE = "https://apps.apple.com/us/app/prothom-alo-north-america/id1289436839";

export const storyTemplatesList = [
  { key: "all", enLabel: "All", bnLabel: "সব" },
  { key: "text", enLabel: "Text", bnLabel: "টেক্সট" },
  { key: "photo", enLabel: "Photo", bnLabel: "ছবি" },
  { key: "video", enLabel: "Video", bnLabel: "ভিডিও" },
  { key: "live-blog", enLabel: "Live-Blog", bnLabel: "সরাসরি" },
  { key: "poll", enLabel: "Poll", bnLabel: "অনলাইন ভোট" },
];

export const sortingList = [
  { key: "default", enLabel: "Relevant", bnLabel: "প্রাসঙ্গিক" },
  { key: "latest-published", enLabel: "Latest", bnLabel: "নতুন থেকে পুরোনো" },
  { key: "published-at:asc", enLabel: "Oldest", bnLabel: "পুরোনো থেকে নতুন" },
];
